import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    // 使用 requestAnimationFrame 确保在浏览器下一次重绘前执行滚动
    // 这样可以避免与其他动画或布局操作冲突
    const scrollTimeout = requestAnimationFrame(() => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'auto', // 使用 auto 立即滚动,不使用平滑过渡,避免与页面动画冲突
      });
    });

    return () => {
      cancelAnimationFrame(scrollTimeout);
    };
  }, [pathname, search]); // 同时监听 pathname 和 search 的变化
  return null;
};

export default ScrollToTop;
